/**
 * @param {String} value
 */
export default function convertDate(value = new Date.now(), option = true) {
  const date = new Date(value);

  // DATE
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  // HOUR
  const hour = date.getHours();
  const minutes = date.getMinutes();

  // DAY 1 = 01
  // MONTH 1 = 01
  // HOUR 1 = 01
  // MINUTES 1 = 01
  function pushZeroBeforeNumber(number) {
    if (number.toString().length === 1) return (number = '0' + number);
    return number;
  }

  const dayConvert = pushZeroBeforeNumber(day);
  const monthConvert = pushZeroBeforeNumber(month);
  const hourConvert = pushZeroBeforeNumber(hour);
  const minutesConvert = pushZeroBeforeNumber(minutes);

  if (option)
    return `${dayConvert}/${monthConvert}/${year} ${hourConvert}:${minutesConvert}`;
  return `${dayConvert}/${monthConvert}/${year}`;
}
